/**
 * Shared maths for the "relative" metric bars used by the creative-ads, tag and
 * story-pattern tables. Every one of those surfaces scales its values against
 * the strongest row in the current view, so the leader fills the bar at 100%
 * and everything else scales proportionally.
 */

/** Scale `value` against `max` into a 0-100 percentage, clamped at 100. */
export const relativePct = (value: number, max: number): number => (max > 0 ? Math.min(100, (value / max) * 100) : 0)

/**
 * Bar opacity tracks the value so weaker rows visually fade out. The 0.25 floor
 * keeps even the weakest bar visible instead of fading it to nothing.
 */
export const barOpacityForPct = (pct: number): number => 0.25 + (pct / 100) * 0.75

/**
 * Strongest install share in a set of ads, used as the `max` for
 * {@link relativePct}. Ads without an `installShare` (no month selected) count
 * as 0 rather than being dropped, so an all-missing set yields 0 and the bars
 * render empty instead of NaN.
 */
export const maxInstallShareOf = (ads: readonly { installShare?: number }[]): number => ads.reduce((max, ad) => Math.max(max, ad.installShare ?? 0), 0)
